import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { ISSUE_QUALIFICATIONS, ISSUE_STATES } from '../lib/issues';
import { Select } from './Select';

// Repo Issues tab toolbar (arc 101 slice 06): the two axes the API declares
// filterable (`ISSUE_LIST_SPEC`) — state + qualification. A change resets the
// list to page one; the container owns that reset via the callbacks.
//
// Each filter is a standalone `label[for]` over the themed Select's trigger, not a
// wrapping label: the trigger is a button, and the open listbox names itself by the
// label's own `${id}-label`, so both ids below are load-bearing.

export function RepoIssuesFilters(props: {
  state: string;
  qualification: string;
  onState: (v: string) => void;
  onQualification: (v: string) => void;
}): JSX.Element {
  return (
    <div class="filter-row">
      <div class="repo-issues__field">
        <label
          class="repo-issues__field-label"
          for="repo-issues-state"
          id="repo-issues-state-label"
        >
          {t('repo_detail.issues_filter_state')}
        </label>
        <Select
          a11y={{ id: 'repo-issues-state' }}
          label={t('repo_detail.issues_filter_state')}
          value={props.state}
          options={ISSUE_STATES.map((v) => ({
            value: v,
            label: t(`repo_detail.issues_state_${v || 'all'}`),
          }))}
          onChange={props.onState}
        />
      </div>
      <div class="repo-issues__field">
        <label
          class="repo-issues__field-label"
          for="repo-issues-qualification"
          id="repo-issues-qualification-label"
        >
          {t('repo_detail.issues_filter_qualification')}
        </label>
        <Select
          a11y={{ id: 'repo-issues-qualification' }}
          label={t('repo_detail.issues_filter_qualification')}
          value={props.qualification}
          options={ISSUE_QUALIFICATIONS.map((v) => ({
            value: v,
            label: t(`repo_detail.issues_qual_${v || 'all'}`),
          }))}
          onChange={props.onQualification}
        />
      </div>
    </div>
  );
}
